import { useCallback, useEffect, useState } from "react";

import { Outlet } from "react-router-dom";

import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import Breadcrumb from "./Breadcrumb";
import "./AdminLayout.css";

const COLLAPSED_KEY = "admin-sidebar-collapsed";

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem(COLLAPSED_KEY) === "true";
  });
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(COLLAPSED_KEY, String(collapsed));
  }, [collapsed]);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const toggleMobileSidebar = useCallback(() => {
    setMobileSidebarOpen((prev) => !prev);
  }, []);

  const closeMobileSidebar = useCallback(() => {
    setMobileSidebarOpen(false);
  }, []);

  return (
    <div className={`admin-layout${collapsed ? " admin-layout--collapsed" : ""}`}>
      <AdminSidebar
        collapsed={collapsed}
        onToggleCollapse={toggleCollapsed}
        mobileOpen={mobileSidebarOpen}
        onCloseMobile={closeMobileSidebar}
      />
      <div className="admin-main">
        <AdminTopBar onToggleMobileSidebar={toggleMobileSidebar} />
        <div className="admin-content">
          <Breadcrumb />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
